export const MAIN_PATH = {};
export const PAGE_PATH = {
  ROOT: '/',
  CLIENT_LOGIN: '/ClientLogin',
  LOGOUT: '/logout',
  INITIALIZE: '/initialize',
  EDIT: '/edit',
  DETAIL: '/detail',
  ERROR: '/error',
  MAINTENANCE: '/maintenance',
  NOT_FOUND: '*',
};
